import React, { useContext } from 'react';
import type { NextPage } from 'next'
import Head from 'next/head'
import {InputText} from "primereact/inputtext";
import {Button} from "primereact/button";
import Image from "next/image";

// Form Data
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import { pt } from 'yup-locale-pt';
import {AuthContext} from "../../../.contexts/AuthContext";
import {ToastContext} from "../../../.contexts/ToastContext";
import FieldMessage from "../../../components/FieldMessage/FieldMessage";
import {Password} from "primereact/password";
import {classNames} from "primereact/utils";
import Link from "next/link";
import OtpLoginFlow from "../../../components/OtpLoginFlow/Index";
import {requestFellowOtp} from "../../../services/authService";
yup.setLocale(pt);

const schema = yup.object({
    email: yup.string().email().required().label('E-mail'),
    password: yup.string().required().label('Senha'),
}).required();

const defaultValues = {
    email: '',
    password: '',
}

const LoginAsFellow: NextPage = () => {

    const { signIn, signInFellowWithOtp } = useContext(AuthContext)
    const { showToast }  = useContext(ToastContext);
    const [isLoading, setLoading] = React.useState(false);
    const [useOtp, setUseOtp] = React.useState(false);
    const { control, formState: { errors }, handleSubmit, getValues } = useForm({
        defaultValues:defaultValues,
        resolver: yupResolver(schema)
    });

    const onSubmit = async (data:any) => {
        try{
            data.type = 'resident';
            setLoading(true);
            await signIn(data)
        }catch(error : any){
            showToast({
                severity:'error',
                summary: 'Erro ao processar esta requisição:',
                detail: error.message === "The user credentials were incorrect." ? "E-mail/Senha inválidos." : error.message,
                life: 3000
            })
        }finally {
            setLoading(false);
        }
    }

    return (
        <div>
            <Head>
                <title>Página de Login - Plataforma de Serviços Formadores Credenciados</title>
            </Head>
            <main>
                <div className="min-h-screen flex">
                    <div className="surface-section w-full md:w-6 p-6 md:p-8">
                        <div className="mb-5">
                            <Image
                                src="/logo-customer.png"
                                alt="logo-customer"
                                width={200}
                                height={80}
                                className="mb-3 fadein animation-duration-1000"/>
                            <h3
                                className="text-3xl font-medium mb-3 fadein animation-duration-1000"
                                style={{color: "#293988"}}
                            >
                                Bem vindo de volta, <b className="underline">Fellow!</b>
                            </h3>
                            <p className="font-light mr-2 fadein animation-duration-1000" style={{color: "#293988"}}>
                                Plataforma de Serviços Formadores Credenciados
                            </p>
                        </div>
                        {!useOtp && <form onSubmit={handleSubmit(onSubmit)} className="fadein animation-duration-1000">
                            <label htmlFor="email" className="block text-900 font-medium mb-2">E-mail:</label>
                            <span className="p-input-icon-left mb-2" style={{display: 'flex'}}>
                                <i className="pi pi-envelope"/>
                                <Controller name="email" control={control} render={({field, fieldState}) => (
                                    <>
                                        <InputText
                                            placeholder="Insira seu e-mail"
                                            type="email" id={field.name}
                                            {...field}
                                            autoFocus
                                            className={classNames({'p-invalid': fieldState.invalid}, 'w-full')}
                                        />
                                    </>
                                )}/>
                            </span>
                            <FieldMessage name="email" error={errors.email}/>

                            <label htmlFor="password" className="block text-900 font-medium mt-3 mb-2">Senha:</label>
                            <span className="p-input-icon-left mb-2" style={{width: '100%'}}>
                                <i className="pi pi-lock"/>
                                <Controller name="password" control={control} render={({field, fieldState}) => (
                                    <Password
                                        placeholder="Insira sua senha"
                                        type="password"
                                        id={field.name}
                                        {...field}
                                        autoFocus
                                        feedback={false}
                                        toggleMask={false}
                                        width={'100%'}
                                        style={{width: '100%'}}
                                        className={classNames({'p-invalid': fieldState.invalid})}
                                    />
                                )}/>
                            </span>
                            <FieldMessage name="password" error={errors.password}/>

                            <div className="flex align-items-center justify-content-between mt-3 mb-4">
                                <span></span>
                                <Link href={"/auth/recovery-password"} style={{color: '#29378b'}}
                                      className="font-medium no-underline ml-2 text-right cursor-pointer">
                                    Esqueceu sua senha ?</Link>
                            </div>

                            <Button type="submit" label="Entrar" loading={isLoading} icon="pi pi-sign-in"
                                    className="w-full py-3"/>
                            <Button type="button" label="Entrar com código por e-mail" outlined
                                    className="w-full py-3 mt-3" onClick={() => setUseOtp(true)}/>
                            <div className="w-full text-center font-medium mt-4">
                                <Link
                                    href={"/auth/login-as-manager"}
                                    style={{color: '#29378b'}}
                                    className="w-full text-center font-medium underline text-center cursor-pointer">
                                    Entrar como Chefe do Programa</Link>
                            </div>
                        </form>}
                        {useOtp && <OtpLoginFlow
                            initialEmail={getValues('email')}
                            requestCode={requestFellowOtp}
                            verifyCode={(challengeId, code) => signInFellowWithOtp({challengeId, code})}
                            onCancel={() => setUseOtp(false)}
                            onError={(message) => showToast({severity: 'error', summary: 'Erro ao processar esta requisição:', detail: message, life: 4000})}
                        />}
                    </div>
                    <div className="hidden md:block w-6 bg-no-repeat bg-cover fadein animation-duration-1000"
                         style={{backgroundImage: "url('/login-fellow-image.png')", backgroundPosition: "center"}}></div>
                </div>
            </main>
        </div>
    )
}

export default LoginAsFellow
